import React, { useState } from 'react'
import GenericModal from '../generic-modal/generic-modal'
import './otp-modal.scss'
import Button from '../../atoms/button/button'
import AuthService from '../../../services/auth-service'

const OtpModal = props => {
  const { nextFunct, setCommondModal } = props;

  

  const token = JSON.parse(localStorage.getItem('TOKEN_INFO')).idToken

  const config = {
    headers: {
      Authorization: token,
    }
  }
  const [inputValueOTP, setInputValueOTP] = useState('')
  const [step, setstep] = useState(0)

  const [disableButton, setdisableButton] = useState(false)
  const [codeDestination, setcodeDestination] = useState('EMAIL')
  const [response, setResponse] = useState('waiting')
  const [noCellphoneError, setnoCellphoneError] = useState(null)

  const [resentCode, setresentCode] = useState(false)
  const [disableResend, setdisableResend] = useState(false)

  const [nextButtonDisable, setnextButtonDisable] = useState(true)

  const sendCode = (reSend) => {
    setdisableButton(true)

    if (reSend) {
      setresentCode(true)
      setdisableResend(true)
      setTimeout(() => {
        setresentCode(false)
        setdisableResend(false)
      }, 10000);
    }

    AuthService.sendOTP(codeDestination, config).then(res => {

      if (res.status === 200) {
        setdisableButton(false)
        setstep(1)
      } else if(res.status === 400){
        setdisableButton(false)
        setnoCellphoneError(res.userMessage)
      } else {
        console.log(res)
      }

    }).catch(e => console.log(e))
  }

  const handleInputValidation = e => {
    setInputValueOTP(e.target.value)

    var value = e.target.value

    if (e.target.value.length === 6) {
      AuthService.validateOTP(value, config).then(res => {
        if (res.data.valid) {
          setResponse('success')
          setnextButtonDisable(false)
        } else {
          setResponse('error')
        }
      }).catch(e => console.log(e))
    } else {
      setResponse('waiting')
    }
  }

  const step0 = (
    <div className="f-info-otp-container">
      <span
        onClick={() => setCommondModal(null)}
        className="icon2-close f-close-icon"
      />
      <span className="f-title-modal">Necesitamos verificar</span>
      <span className="f-subtitle-modal">QUE ERES TÚ</span>
      <p className="f-description-modal">Necesitamos verificar que eres tú, te enviaremos un código único para que lo ingreses a continuación. Elige el medio por el cuál quieres realizar esta validación.</p>

      <div className="f-radio-container ">
        <div className="f-radio-option">Celular (SMS)
                    <input
            type="radio"
            name="codeDestination"
            onChange={e => {setcodeDestination(e.target.value); setnoCellphoneError(null)}}
            checked={codeDestination==="SMS"}
            defaultValue="SMS"
          />
          <span className="checkmark"></span>
        </div>
        <div className="f-radio-option">Correo
                    <input
            type="radio"
            name="codeDestination"
            onChange={e => {setcodeDestination(e.target.value); setnoCellphoneError(null)}}
            checked={codeDestination==="EMAIL"}
            defaultValue="EMAIL"
          />
          <span className="checkmark"></span>
        </div>
      </div>
      <span className="f-cellphone-error">{noCellphoneError}</span>
      <div className={"f-button-container " + (disableButton ? 'disabled' : '')} onClick={() => sendCode()}>
        <Button
          className="primary-pink short"
          title="Siguiente"
        />
      </div>
    </div>
  )

  const step1 = (
    <div className="f-info-otp-container">
      <span
        onClick={() => setCommondModal(null)}
        className="icon2-close f-close-icon"
      />
      <span className="f-title-modal">Necesitamos verificar</span>
      <span className="f-subtitle-modal">QUE ERES TÚ</span>
      <p className="f-description-modal">Ingresa el código de 6 dígitos que hemos enviado a tu {codeDestination === 'EMAIL' ? 'correo' : 'celular'}.</p>

      <div className="f-input-container">
        <label className="f-input-indicator">
          CÓDIGO VERIFICACIÓN
                </label>
        <div className="f-input-validation-container">
          <input
            name="f-verification-code-input"
            placeholder="Ingresa el código"
            className={"f-verification-code-input " + (response === 'success' && ' f-success-validation ') + (response === 'error' && ' f-error-validation')}
            type='text'
            maxLength='6'
            autoComplete="off"
            value={inputValueOTP}
            onChange={handleInputValidation}
          />
          {response === 'error' && inputValueOTP.length === 6 ? <span className="icon2-close f-icon f-error-code"></span> : null}
          {response === 'success' && inputValueOTP.length === 6 ? <span className="icon-check-2 f-icon f-check-code"></span> : null}

        </div>
        {response === 'error' && inputValueOTP.length === 6 ?
          <label className="f-code-error">
            Código inválido
                    </label>

          :

          null

        }
        <label className="f-send-code">
          ¿No recibiste un código? <span className={"f-link-send-code " + (disableResend ? 'disabled' : '')} onClick={() => sendCode(true)}>Reenviar código</span>
        </label>
        {resentCode && <p className="f-send-code-re">Tu código ha sido enviado</p>}
      </div>

      <span className="f-separator" />

      <div className="f-buttons-container">
        <div className="f-button-container" onClick={() => setstep(0)}>
          <Button
            className="secondary-pink short"
            title="Elegir otro medio"
          />
        </div>

        <div className={"f-button-container " + (nextButtonDisable ? 'disabled' : '')} onClick={() => { console.log(inputValueOTP); setCommondModal(null); nextFunct(inputValueOTP) }}>
          <Button
            className="primary-pink short"
            title="Siguiente"
          />
        </div>
      </div>
    </div>
  )

  // const step2 = (
  //     <div className="f-info-otp-container">
  //         <span className="f-title-modal">Validación exitosa</span>
  //         <p className="f-description-modal">Estás lista para redimir todos los premios que más te gusten de Nosotras.</p>

  //         <div className="f-button-container" onClick={() => {setCommondModal(null); nextFunct()}}>
  //             <Button
  //                 className="primary-pink short"
  //                 title="Aceptar"
  //             />
  //         </div>
  //     </div>
  // )

  return (
    <GenericModal>
      {step === 0 && step0}
      {step === 1 && step1}
      {/* {step === 2 && step2} */}
    </GenericModal>
  )
}

export default OtpModal
